// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__y2mj8","tableExams":"styles_tableExams__L4Yko","tableExams_thead":"styles_tableExams_thead__jv4B5","tableExams_tbody":"styles_tableExams_tbody__gk4pr"};